var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var ErrorMessageStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: center;\n  text-align: center;\n"], ["\n  align-self: center;\n  text-align: center;\n"])));
var templateObject_1;
//# sourceMappingURL=ErrorMessageStyled.js.map